/**
 * Plain-text preview of a (possibly markdown) note body, for the compact list
 * card. The full body renders as rich markdown in the note dialog; the card
 * only needs a short, scannable snippet — so strip markdown syntax, drop any
 * table rows entirely, collapse whitespace, and truncate.
 */
export function notePreview(content: string, maxLen = 180): string {
  const text = (content ?? '')
    // markdown links [text](url) -> text
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    // drop whole table rows: GFM (lines starting with |) and box-drawing art
    .replace(/^[ \t]*[|│┌├└┬┴┼┐┘─].*$/gm, ' ')
    // ATX heading + blockquote markers, but only at line start (so a mid-text
    // "#101" or ">50%" is left intact)
    .replace(/^[ \t]*#{1,6}[ \t]+/gm, '')
    .replace(/^[ \t]*>[ \t]?/gm, '')
    // unwrap paired emphasis only — leaves intraword punctuation like
    // `drone_serial` or `C++` untouched
    .replace(/(\*\*|__|~~)(.+?)\1/g, '$2')
    .replace(/\*([^*\n]+)\*/g, '$1')
    .replace(/`([^`\n]+)`/g, '$1')
    // collapse all whitespace (including the newlines markdown relies on)
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > maxLen ? `${text.slice(0, maxLen).trimEnd()}…` : text;
}
